import React from 'react';
import type TrashedProjectsAdminType from '@atlassian/jira-spa-apps-trashed-projects/src/index.tsx';
import { markAsProductBundleReady } from '@atlassian/jira-spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

export const LazyTrashedProjectsAdmin = lazyForPaint<typeof TrashedProjectsAdminType>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-trashed-projects", jiraSpaEntry: "async-trashed-projects" */ '@atlassian/jira-spa-apps-trashed-projects'
		),
	),
);

const AsyncTrashedProjectsAdmin = (): React.JSX.Element => (
	<LazyPage Page={LazyTrashedProjectsAdmin} pageId="trashed-projects" shouldShowSpinner />
);

export default AsyncTrashedProjectsAdmin;
